import { useState } from "react";

import FormFieldViewText from "components/FormFields/ViewText";
import { TIER_PLANS_LABELS } from "constants/tiers";
import Box from "ds/components/Box";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import FullScreenModal from "ds/components/FullScreenModal";
import { AnalyticsPageBilling } from "hooks/useAnalytics/pages/billing";
import useTypedContext from "hooks/useTypedContext";
import { BillingSubscription } from "types/generated";

import BillingCancelSubscriptionConfirmation from "../CancelSubscription/Confirmation";
import { BillingContext } from "../Context";
import BillingSubscriptionManagementLayout from "../SubscriptionManagement/Layout";
import { StripeSubscriptionStatus } from "../types";
import { formatBillingDate } from "../utils";

type BillingLegacySubscriptionManagementProps = {
  billingSubscription: BillingSubscription;
};

const BillingLegacySubscriptionManagement = ({
  billingSubscription,
}: BillingLegacySubscriptionManagementProps) => {
  const { tier } = useTypedContext(BillingContext);
  const [isCancelModalShown, setIsCancelModalShown] = useState(false);

  return (
    <>
      <BillingSubscriptionManagementLayout
        subscriptionStatus={billingSubscription.status as StripeSubscriptionStatus}
        actions={
          <DropdownMenuEllipsis tooltip="Subscription actions">
            {billingSubscription.selfServePortalUrl && (
              <DropdownMenuItem
                href={billingSubscription.selfServePortalUrl}
                target="_blank"
                rel="noopener noreferrer"
                analyticsPage={AnalyticsPageBilling.BillingSubscription}
                analyticsTitle="Manage Payments Clicked"
              >
                Manage payments
              </DropdownMenuItem>
            )}

            <DropdownMenuItem onAction={() => setIsCancelModalShown(true)} danger>
              Cancel
            </DropdownMenuItem>
          </DropdownMenuEllipsis>
        }
      >
        <Box direction="column">
          <FormFieldViewText label="Plan type" value={TIER_PLANS_LABELS[tier]} />
          {billingSubscription.billingRenewalDate && (
            <FormFieldViewText
              label="Next renewal"
              value={formatBillingDate(billingSubscription.billingRenewalDate)}
            />
          )}
          {billingSubscription.billingAmount != null && (
            <FormFieldViewText
              label="Next payment amount"
              value={`$${(billingSubscription.billingAmount / 100).toFixed(2)}`}
            />
          )}
        </Box>
      </BillingSubscriptionManagementLayout>

      {isCancelModalShown && (
        <FullScreenModal title="Cancel subscription" onClose={() => setIsCancelModalShown(false)}>
          <BillingCancelSubscriptionConfirmation onClose={() => setIsCancelModalShown(false)} />
        </FullScreenModal>
      )}
    </>
  );
};

export default BillingLegacySubscriptionManagement;
